export function getRandom(min, max) {
  var mynum = Math.random() * (max - min) + min;
  mynum = Math.floor(mynum);
  return mynum;
}
